import React, {useState} from 'react';
import { Grid } from '@material-ui/core';
import SearchableTable from '../components/peoplerender';
import Content from '../components/Content';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import EmpIcon from '@material-ui/icons/PermContactCalendar';
import WfIcon from '@material-ui/icons/Repeat';
import InactiveIcon from '@material-ui/icons/Cancel'

import Workflow from '../components/workflowrender';

import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const options = [
	'Create WF',
	'Back'
  ];
  
const ITEM_HEIGHT = 48;

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	
	return (
		<div
		role="tabpanel"
		hidden={value !== index}
		id={`scrollable-force-tabpanel-${index}`}
		aria-labelledby={`scrollable-force-tab-${index}`}
		{...other}
		>
		{value === index && (
			<Box>
				{children}
			</Box>
		)}
		</div>
	);
	}
	  
	TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
	};
	
   function a11yProps(index) {
		return {
		  id: `scrollable-force-tab-${index}`,
		  'aria-controls': `scrollable-force-tabpanel-${index}`,
		};
	  }

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		width: '100%',
		backgroundColor: theme.palette.background.paper,
		height: 240,
		maxWidth: 400,
	},
	heading: {
	  fontSize: theme.typography.pxToRem(15),
	  fontWeight: theme.typography.fontWeightRegular,
	},
  }));

const PeopleDetails = () => {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const history = useHistory();

	const [rowsToPush, setRowsToPush] = useState([]);
	const [selectedRawEdit, setSelectedRawEdit] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);
  	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		console.log(e.target.textContent);
		switch(e.target.textContent){
			case 'Create WF':
				history.push({pathname: '/workflow/create'});
				break;
			case 'Back':
				history.goBack();
				break;
			default:
		}
		
		setAnchorEl(null);
	};
	const handleChange = (event, newValue) => {
    	setValue(newValue);
  	};

 return (
		<Content>
			<div>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleClick}
				>
				<MoreVertIcon />
				</IconButton>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
				><span>People and Workflow Details</span>
				</IconButton>
				
				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 5,
						width: '20ch',
					},
					}}
				>
					{options.map((option) => (
					<MenuItem key={option} selected={option === 'Pyxis'} onClick={(e)=>handleClose(e)}>
						{option}
					</MenuItem>
					))}
				</Menu>
			</div>
	 <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs example"
        >
          <Tab label="Employee Master" icon={<EmpIcon />} {...a11yProps(0)} />
          <Tab label="Approval Workflow" icon={<WfIcon />} {...a11yProps(1)} />
		  <Tab label="Inactive Records" icon={<InactiveIcon />} {...a11yProps(2)} />
        </Tabs>
      </AppBar>

	   <TabPanel value={value} index={0}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Employee Master</p>     

			<Grid item xs={12} md={12}>
				<SearchableTable
					table = {'employees'}
                    //qString = "&fullname=" 
					defaultSortColumn = "lastName"
					keyIdentifier = "idMaster"
					filterTable = ""
					filters = { true }
					filterQuery
					enableFormEdit = { true }
					enableRawEdit = { true }
					selectedRawEdit = { [selectedRawEdit] }
					enableSelect = { false }
					useDataRowsFromParent = { false }
					displayedHeaders={[
						{
							key: 'fullname',
							displayedHeader: 'Name',
							displayedLength: 250,
							withList: false,
							readOnly: false,
							listPath: 'employees'
						},	
						{
							key: 'companyName',
							displayedHeader: 'Business Unit',
							displayedLength: 250,
							withList: true,
							readOnly: false,
							listPath: 'company'
						},
						{
							key: 'deptName',
							displayedHeader: 'Department',
							displayedLength: 250,
							withList: true,
							readOnly: false,
							listPath: 'depts'
						}
						
					]}
					displayRows = {[
						//{ key: 'idMaster', displayedHeader: 'ID', type: 'id' },
						{
							key: 'empId',
							displayedHeader: 'Emp ID',
							displayedLength: 25,
						},
						{
							key: 'fullname',
							displayedHeader: 'Employee Name',
							displayedLength: 60,
						},
						{
							key: 'userName',
							displayedHeader: 'Ad Account',
							displayedLength: 70,
						},
						{
							key: 'company',
							displayedHeader: 'Business Unit',
							displayedLength: 50,
						},
						{
							key: 'department',
							displayedHeader: 'Department',
							displayedLength: 50,
						}
					]}
				/>
			</Grid>
			</TabPanel>
 
   <TabPanel value={value} index={1}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>FAMAS Approval Workflow</p>   
	  <Grid item xs={12} md={12}> <Workflow qString = "active" /></Grid>
   </TabPanel>

   
   <TabPanel value={value} index={2}>
	  <p style={{padding:5, fontWeight:'bold',color:'cadetblue'}}>Inactive Records</p>   
	  <Grid item xs={12} md={12}> <Workflow qString = "inactive" /></Grid>
   </TabPanel>
</Content>
);
};

export default PeopleDetails;
